import React from 'react'
import { useTranslation } from 'react-i18next'

import { formatMoney, formatDate } from 'helpers/helpers'

// Универсальный просмотр документа из детализации остатка. Вёрстка повторяет
// печатную форму прихода, чтобы любой документ читался одинаково.
// Строки берутся из истории движений, поэтому совпадают с отчётом.
function DocumentRightbar({ showRightBar, setShowRightBar, data, documentName, posName }) {
	const { t } = useTranslation()

	const document = data?.document ?? {}
	const items = data?.items ?? []

	// В инвентаризации в леджер уходит расхождение, а в документе человек ищет
	// своё посчитанное количество — его и показываем как количество позиции.
	const isInventory = document.type === 'inventory'

	function quantityOf(item) {
		if (isInventory && item.counted_quantity !== null && item.counted_quantity !== undefined) {
			return Number(item.counted_quantity)
		}
		return Number(item.quantity ?? 0)
	}

	function amountOf(item) {
		if (isInventory) return quantityOf(item) * Number(item.cost_price ?? 0)
		return Number(item.total_amount ?? 0)
	}

	const overallQuantity = items.reduce((total, item) => total + quantityOf(item), 0)
	const overallAmount = items.reduce((total, item) => total + amountOf(item), 0)

	return (
		<>
			<div className="right-sidebar-background" onClick={() => setShowRightBar(false)}></div>
			<div className="right-sidebar p-2">
				<h4 className="fw-600">
					{t('document_from')} {formatDate(document.created_at, 'dd.MM.yy HH:mm')}
					{document.document_number && <span className="ms-2">№{document.document_number}</span>}
				</h4>
				<div className="flex-column preview-info">
					<div className="d-flex gap-2">
						<div className="fw-600">{t('type')}:</div>
						<div>{documentName}</div>
					</div>
					{posName &&
						<div className="d-flex gap-2">
							<div className="fw-600">{t('pos')}:</div>
							<div>{posName}</div>
						</div>
					}
					{document.wms_name &&
						<div className="d-flex gap-2">
							<div className="fw-600">{t('wms')}:</div>
							<div>{document.wms_name}</div>
						</div>
					}
					{document.from_wms_name &&
						<div className="d-flex gap-2">
							<div className="fw-600">{t('from_wms')}:</div>
							<div>{document.from_wms_name}</div>
						</div>
					}
					{document.to_wms_name &&
						<div className="d-flex gap-2">
							<div className="fw-600">{t('to_wms')}:</div>
							<div>{document.to_wms_name}</div>
						</div>
					}
					{document.counterparty_name &&
						<div className="d-flex gap-2">
							<div className="fw-600">{t('supplier')}:</div>
							<div>{document.counterparty_name}</div>
						</div>
					}
					<div className="d-flex gap-2">
						<div className="fw-600">{t('created_by')}:</div>
						<div>{document.created_by}</div>
					</div>
					{document.note &&
						<div className="d-flex gap-2">
							<div className="fw-600">{t('note')}:</div>
							<div>{document.note}</div>
						</div>
					}
					{document.document_status_name &&
						<div className="d-flex gap-2">
							<div className="fw-600">{t('status')}:</div>
							<div className={`bg-${document.document_status_color ?? 'secondary'} text-white px-2 rounded`}>
								{document.document_status_name}
							</div>
						</div>
					}
				</div>

				<div className="table-responsive">
					<table className="table table-bordered">
						<thead>
							<tr>
								<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
								<th style={{ 'width': '40%' }}>{t('name2')}</th>
								<th style={{ 'width': '10%' }} className="text-end text-nowrap">{t('quantity')}</th>
								<th style={{ 'width': '10%' }} className="text-end text-nowrap">{t('unit')}</th>
								<th style={{ 'width': '20%' }} className="text-end">{t('price')}</th>
								<th style={{ 'width': '20%' }} className="text-end">{t('amount')}</th>
							</tr>
						</thead>
						<tbody>
							{items.map((item, index) => (
								<tr key={index}>
									<td className="text-center" title={item.id}>{index + 1}</td>
									<td title={item.product_id}>{item.product_name}</td>
									<td className="text-end">{formatMoney(quantityOf(item), 3)}</td>
									<td>{item.unit_name}</td>
									<td className="text-end">{formatMoney(item.cost_price)}</td>
									<td className="text-end">{formatMoney(amountOf(item))}</td>
								</tr>
							))}
							{items.length === 0 &&
								<tr>
									<td colSpan="6" className="text-center">{t('list_empty')}</td>
								</tr>
							}
							{items.length > 0 &&
								<tr>
									<td></td>
									<td><b>{t('total')}</b></td>
									<td className="text-end text-nowrap"><b>{formatMoney(overallQuantity, 3)}</b></td>
									<td></td>
									<td></td>
									<td className="text-end text-nowrap"><b>{formatMoney(overallAmount)}</b></td>
								</tr>
							}
						</tbody>
					</table>
				</div>
			</div>
		</>
	)
}

export default DocumentRightbar
